import * as actionTypes from './actionTypes';

const initialState = {
  pageIndex: 1,
  isFetching: false,
  isServiceError: false,
  response: {},
  showCreateBusy: false,
  selectedReport: {},
  showDownloadPopup: false,
  showDeletePopup: false,
  showDeleteProgress: false,
  showCIIAccessBusy: false,
};

const reportsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_INITIAL_STATE:
      return initialState;

    case actionTypes.REPORTS_SERVICE_ERROR:
      return {
        ...state,
        isFetching: false,
        isServiceError: true,
      };
    case actionTypes.REQUEST_REPORTS_DATA:
      return {
        ...state,
        isFetching: true,
        isServiceError: false,
      };
    case actionTypes.RECEIVE_REPORTS_DATA:
      return {
        ...state,
        isFetching: false,
        isServiceError: false,
        response: action.response,
      };

    case actionTypes.SET_PAGE_INDEX:
      return {
        ...state,
        pageIndex: action.pageIndex,
      };

    case actionTypes.SET_CREATE_BUSY_STATUS:
      return {
        ...state,
        showCreateBusy: action.show,
      };

    case actionTypes.SHOW_DELETE_POPUP:
      return {
        ...state,
        selectedReport: action.report,
        showDeletePopup: true,
        showDeleteProgress: false,
      };

    case actionTypes.HIDE_DELETE_POPUP:
      return {
        ...state,
        selectedReport: action.report,
        showDeletePopup: false,
        showDeleteProgress: false,
      };

    case actionTypes.SHOW_DELETE_PROGRESS:
      return {
        ...state,
        showDeleteProgress: true,
      };

    case actionTypes.SHOW_DOWNLOAD_POPUP:
      return {
        ...state,
        selectedReport: action.report,
        showDownloadPopup: true,
      };

    case actionTypes.HIDE_DOWNLOAD_POPUP:
      return {
        ...state,
        selectedReport: action.report,
        showDownloadPopup: false,
      };

    case actionTypes.SET_CIIACCESS_BUSY_STATUS:
      return {
        ...state,
        showCIIAccessBusy: action.show,
      };

    case actionTypes.SHOW_EXPORT_PROGRESS:
      return {
        ...state,
        showRenewalsExportProgress: action.show,
      };  

    case actionTypes.SHOW_CLIENTS_EXPORT_PROGRESS:
      return {
        ...state,
        showClientsExportProgress: action.show,
      }; 

    default:
      return state;
  }
};

export default reportsReducer;
